import { render, staticRenderFns } from "./configuration-relationships.vue?vue&type=template&id=281bd026&scoped=true&"
import script from "./configuration-relationships.ts?vue&type=script&lang=ts&"
export * from "./configuration-relationships.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-relationships.scss?vue&type=style&index=0&id=281bd026&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281bd026",
  null
  
)

export default component.exports